export default __webpack_public_path__ + "static/media/cop8.3f64752e.png";